import { IAppFrom } from "../interfaces/IAppFrom";
export const prioritizeInAppPurchase = (from) => {
    if (from == IAppFrom.REMINDS || from == IAppFrom.KEEPASS || from == IAppFrom.CALENDAR || from == IAppFrom.AICALENDAR) {
        return true;
    }
    return false;
};
